<template>
    <div class="container">
        <span style="font-size: 20px;">菜品分析</span>
        <div class="search-box">
            <span style=" font-size: 14px;margin-right: 10px;">统计周期:</span>
            <div class="type-box">
                <span :class="type === 'week' ? 'active' : ''" @click="changeDate('week')">周</span>
                <span :class="type === 'month' ? 'active' : ''" @click="changeDate('month')"> 月</span>
                <span :class="type === 'daterange' ? 'active' : ''" @click="changeDate('daterange')">自定义</span>
            </div>
            <span style=" font-size: 14px;margin-right: 10px;">营业日期:</span>
            <el-date-picker v-model="dataTime" :type="type" :format="format" :placeholder="placeholder"
                :picker-options="pickerOptions">
            </el-date-picker>
            <!-- <span style=" font-size: 14px;margin:0 10px;">统计方式:</span>
            <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select> -->
            <el-button type="primary" icon="el-icon-search"
                style="margin-left: 20px;background-color: #f59a23;border: none;" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" style="margin-left: 20px;" @click="reset">重置</el-button>
        </div>
        <el-card class="box-card">
            <span class="title">销售趋势</span>
            <div class="line"></div>
            <!--   <div class="grid-list">
                <div class="grid-content" :class="active === 0 ? 'active' : ''" @click="changeActive(0)">
                    <div class="grid-item">
                        <span class="name">
                            销售数量
                        </span>
                        <span class="num">
                            42
                        </span>
                        <div class="des">
                            <span>较上月 +42</span>
                            <i class="el-icon-top i-orange">100%</i>
                        </div>
                    </div>

                </div>
                <div class="grid-content" :class="active === 1 ? 'active' : ''" @click="changeActive(1)">
                    <div class="grid-item">
                        <span class="name">
                            销售额(元)
                        </span>
                        <span class="num">
                            42
                        </span>
                        <div class="des">
                            <span>较上月 +42</span>
                            <i class="el-icon-top i-orange">100%</i>
                        </div>
                    </div>
                </div>
                <div class="grid-content" :class="active === 2 ? 'active' : ''" @click="changeActive(2)">
                    <div class="grid-item">
                        <span class="name">
                            菜品收入(元)
                        </span>
                        <span class="num">
                            42
                        </span>
                        <div class="des">
                            <span>较上月 +42</span>
                            <i class="el-icon-top i-orange">100%</i>
                        </div>
                    </div>
                </div>
                <div class="grid-content" :class="active === 3 ? 'active' : ''" @click="changeActive(3)">
                    <div class="grid-item">
                        <span class="name">
                            菜品动销率
                        </span>
                        <span class="num">
                            42
                        </span>
                        <div class="des">
                            <span>较上月 +42</span>
                            <i class="el-icon-top i-orange">100%</i>
                        </div>
                    </div>
                </div>
            </div> -->
            <div style="width: 100%;height: 400px;margin:20px auto;" id="lineChart"></div>
        </el-card>
        <el-card class="box-card">
            <span class="title">销售概览</span>
            <div class="search-box">
                <!--  <span style=" font-size: 14px;margin-right: 10px;">统计维度:</span> -->
                <div class="chart-btn-box">
                    <span :class="tabActive == 0 ? 'tab-active' : ''" @click="changeTab(0)">销售数量</span>
                    <span :class="tabActive == 1 ? 'tab-active' : ''" @click="changeTab(1)">销售额</span>
                </div>
                <!-- <span style=" font-size: 14px;margin:0 10px;">价格区间:</span>
                <el-input v-model="price" type="number" placeholder="请输入价格" style="width: 200px;">
                    <template slot="suffix">
                        元
                    </template>
</el-input>
<el-button type="primary" size="mini" icon="el-icon-search"
    style="margin-left: 20px;background-color: #f59a23;border: none;">查询</el-button> -->
            </div>
            <div>
                <!--  <el-table :data="tableData" style="width: 100%" :summary-method="getSummaries" show-summary
                    :header-cell-style="{ background: '#fafafa', padding: '14px 0' }">
                    <el-table-column prop="name" label="菜品名称">
                    </el-table-column>
                    <el-table-column v-for="(column, index) in columns" :key="index" :prop="column.prop"
                        :label="column.label"></el-table-column>
                </el-table> -->
                <div style="width: 100%;height: 400px;margin: auto;" id="barChart"></div>
            </div>
        </el-card>

    </div>
</template>

<script>
import * as echarts from 'echarts'
//moment 引入
import moment from 'moment'
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
export default {
    name: '',
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.getTime();
                }
            },
            type: 'month',
            dataTime: currentDate,
            format: 'yyyy/MM',
            vformat: 'yyyy/MM',
            placeholder: '选择月',
            options: [{
                value: 1,
                label: '单品+套餐明细'
            }, {
                value: 2,
                label: '单品+套餐'
            },],
            value: 1,
            active: 0,
            tabActive: 0,
            price: 20,
            tableData: [


            ],
            columns: [],
            merchantCode: localStorage.getItem('merchantCode'),
        };
    },
    mounted() {
        this.dataTime = currentDate
        this.initLineChart()
        this.initBarChart()
    },
    methods: {
        search() {
            this.initLineChart()
            this.initBarChart()
        },
        reset() {
            this.dataTime = currentDate
            this.format = 'yyyy/MM';
            this.vformat = 'YYYY/MM';
            this.placeholder = '选择月';
            this.type = 'month';
            this.initLineChart()
            this.initBarChart()
        },
        changeDate(type) {
            //moment.js 格式化时间

            this.dataTime = currentDate
            if (type === 'week') {
                this.format = 'yyyy/W';
                this.vformat = 'yyyy/W';
                this.placeholder = '选择周';
            } else if (type === 'month') {
                this.format = 'yyyy/MM';
                this.vformat = 'YYYY/MM';
                this.placeholder = '选择月';
            } else if (type === 'daterange') {
                this.dataTime = [currentDate, currentDate]
                this.format = 'yyyy-MM-dd';
                this.vformat = 'YYYY-MM-DD';
                this.placeholder = '选择日期范围';
            }
            this.type = type;
        },
        changeActive(index) {
            this.active = index;

        },
        changeTab(index) {
            this.tabActive = index;
            console.log(this.tabActive)
            this.initBarChart()
        },

        // 初始化折线图
        async initLineChart() {
            let timeType = this.type === 'week' ? 2 : this.type === 'month' ? 3 : 6
            let startTime = null
            let endTime = null
            let xAxis = []
            let data1 = []
            let data2 = []
            let time = null
            if (timeType == 6) {
                if (this.dataTime != null && this.dataTime.length > 0) {
                    startTime = moment(this.dataTime[0]).format(this.vformat)
                    endTime = moment(this.dataTime[1]).format(this.vformat)
                } else {
                    this.$message.error('请选择时间范围')
                    return
                }
            } else {
                if (this.dataTime === null || this.dataTime === '') {
                    this.$message.error('请选择时间范围')
                    return
                }
                time = moment(this.dataTime).format(this.vformat)

            }
            let params = {
                timeType: timeType,
                startTime: startTime,
                endTime: endTime,
                code: this.merchantCode,
                time: time
            }
            let res = await this.$http.post('/merchantOrderHistory/saleTrend', params)
            if (res.data.code == 200) {
                let datas = res.data.data
                xAxis = datas.map(item => item.time)
                data1 = datas.map(item => item.count)
                data2 = datas.map(item => item.totalNum)
            }
            let max1 = data1.length > 0 ? Math.max(...data1) : 1000
            let min1 = data1.length > 0 ? Math.min(...data1) : 0
            let interval1 = Math.ceil(max1 / 10)
            let max2 = data2.length > 0 ? Math.max(...data2) : 1000
            let min2 = data2.length > 0 ? Math.min(...data2) : 0
            let interval2 = Math.ceil(max2 / 10)
            let lineChart = echarts.init(document.getElementById('lineChart'));
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    bottom: 10,
                    icon: 'circle' // 设置图例图标为圆形
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '16%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxis,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false // 隐藏Y轴的刻度线
                        },
                        axisLabel: {
                            color: '#808080'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '单位：个',
                        min: min1,
                        max: max1,
                        interval: interval1,
                        position: 'left',
                        splitLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#cecece'
                            },
                            onZero: false // 确保轴线不在零刻度线上
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false // 隐藏Y轴的刻度线
                        },
                        axisLabel: {
                            color: '#808080'
                        }

                    },
                    {
                        type: 'value',
                        name: '单位：元',
                        min: min2,
                        max: max2,
                        interval: interval2,
                        position: 'right',
                        splitLine: {
                            show: false,
                            onZero: false // 确保轴线不在零刻度线上
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false // 隐藏Y轴的刻度线
                        },
                        axisLabel: {
                            color: '#808080'
                        }

                    }
                ],
                series: [
                    {
                        name: '销售数量',
                        type: 'line',
                        yAxisIndex: 0,
                        stack: 'Total2',
                        itemStyle: {
                            color: '#f59a23'
                        },
                        symbol: 'none',
                        data: data1,
                        label: {
                            show: true, // 显示标签
                            position: 'top' // 标签的位置，可以是 'top', 'bottom', 'left', 'right', 'inside', 'insideTop', 'insideBottom', 'insideLeft', 'insideRight', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight'
                        }
                    },
                    {
                        name: '销售额',
                        type: 'line',
                        yAxisIndex: 1,
                        stack: 'Total',
                        itemStyle: {
                            color: '#6AB1FF'
                        },
                        symbol: 'none',
                        data: data2,
                        label: {
                            show: true, // 显示标签
                            position: 'top' // 标签的位置，可以是 'top', 'bottom', 'left', 'right', 'inside', 'insideTop', 'insideBottom', 'insideLeft', 'insideRight', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight'
                        }
                    }
                ]
            };
            lineChart.setOption(option);
            window.addEventListener('resize', () => {
                lineChart.resize()
            })
        },
        //初始化柱状图
        async initBarChart() {
            let name = this.tabActive == 0 ? '销售数量' : '销售额'
            let timeType = this.type === 'week' ? 2 : this.type === 'month' ? 3 : 6
            let startTime = null
            let endTime = null
            let xAxis = []
            let data1 = []
            let data2 = []
            let time = null
            if (timeType == 6) {
                if (this.dataTime != null && this.dataTime.length > 0) {
                    startTime = moment(this.dataTime[0]).format(this.vformat)
                    endTime = moment(this.dataTime[1]).format(this.vformat)
                } else {
                    this.$message.error('请选择时间范围')
                    return
                }
            } else {
                if (this.dataTime === null || this.dataTime === '') {
                    this.$message.error('请选择时间范围')
                    return
                }
                time = moment(this.dataTime).format(this.vformat)

            }
            let params = {
                timeType: timeType,
                startTime: startTime,
                endTime: endTime,
                code: this.merchantCode,
                time: time
            }
            let res = await this.$http.post('/merchantOrderHistory/saleTrend', params)
            if (res.data.code == 200) {
                let datas = res.data.data
                xAxis = datas.map(item => item.time)
                data1 = datas.map(item => item.count)
                data2 = datas.map(item => item.totalNum)
            }

            let barChart = echarts.init(document.getElementById('barChart'));
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    bottom: 10,
                    icon: 'circle' // 设置图例图标为圆形
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '16%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxis,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false // 隐藏Y轴的刻度线
                        },
                        axisLabel: {
                            color: '#808080'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: this.tabActive == 1 ? '单位：元' : '单位：个',
                        splitLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#cecece'
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false // 隐藏Y轴的刻度线
                        },
                        axisLabel: {
                            color: '#808080'
                        }

                    }
                ],
                series: [
                    {
                        name: name,
                        type: 'bar',
                        itemStyle: {
                            color: this.tabActive == 0 ? '#f59a23' : '#6AB1FF'
                        },
                        data: this.tabActive == 0 ? data1 : data2,
                        label: {
                            show: false, // 显示标签
                            position: 'top' // 标签的位置，可以是 'top', 'bottom', 'left', 'right', 'inside', 'insideTop', 'insideBottom', 'insideLeft', 'insideRight', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight'
                        }
                    }
                ]
            };
            barChart.setOption(option);
            window.addEventListener('resize', () => {
                barChart.resize()
            })
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += ' 元';
                } else {
                    sums[index] = '--';
                }
            });

            return sums;
        },
        //处理表格数据动态获取columns
        generateColumns() {
            if (this.tableData.length > 0) {
                const firstRow = this.tableData[0];
                this.columns = Object.keys(firstRow).map((key) => {
                    // 排除 'name' 键，如果需要显示 'name' 列，可以将其添加到 columns 中
                    if (key !== 'name') {
                        return { prop: key, label: key };
                    }
                }).filter(Boolean); // 过滤掉 undefined 的元素
                console.log(this.columns, '====');
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;

    background-color: #fff;
    padding: 20px;

    .search-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 20px;



        .type-box {
            display: flex;
            align-items: center;
            margin-right: 20px;
            justify-content: flex-start;

            span {
                padding: 0 10px;
                cursor: pointer;
                color: #333;
                border: 1px solid #cecece;
                font-size: 14px;
            }

            .active {
                color: #f59a23;
                border: 1px solid #f59a23;
            }
        }
    }

    .box-card {
        width: 98%;
        min-height: 500px;
        margin-top: 20px;

        .title {
            font-size: 18px;
            color: #333;
            position: relative;
            font-weight: bold;

        }

        .title::after {
            content: '';
            width: 100%;
            height: 4px;
            background-color: rgba(255, 189, 0, .7);
            position: absolute;
            bottom: 3px;
            left: 0;
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #ccc;
            margin-top: 10px;
        }


        .grid-list {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            gap: 20px;
            width: 98%;

            .grid-content {
                flex: 1;
                display: flex;
                justify-content: start;
                align-items: center;
                height: 100px;
                border: 1px solid #ccc;
                border-radius: 5px;
                padding-left: 20px;

                .grid-item {
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    justify-content: start;
                    gap: 5px;
                    height: 70px;
                    margin-right: 20px;

                    .name {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #666;
                    }

                    .num {
                        font-size: 20px;
                        font-weight: 500;
                        color: #222;
                    }

                    .des {
                        display: flex;
                        align-items: center;
                    }

                    .i-red {
                        color: #ff0000;
                    }

                    .i-orange {
                        color: #fe8c00;
                    }
                }

            }

            .active {
                background: rgba(255, 189, 0, .1);
                border: 1px solid #ffbd00;
            }
        }

        .chart-btn-box {

            display: flex;
            align-items: center;
            justify-content: start;

            span {
                cursor: pointer;
                padding: 0 4px;
                font-size: 14px;
                color: #333;
                border: 1px solid #cecece;
            }

            .tab-active {
                color: #ff6000;
                border: 1px solid #ff6000;

            }
        }
    }
}

/deep/ .el-input__suffix-inner {
    pointer-events: all;
    display: flex;
    align-items: center;
    height: 100%;
}
</style>